var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtCardDebt = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h70v70H0V0z",
    id: "nj40qaeoca"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    xlinkHref: "#nj40qaeoca"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h70v70H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D6EEF2",
    d: "m10.636 19.16 24.716 14.353 23.964-14.037L34.727 5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A9CFD8",
    d: "M35.352 33.513 40.708 65 65 51.077l-5.684-31.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BAD8DD",
    d: "M10.636 19.16 5 44.145 40.708 65l-5.356-31.487z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.396 12.985 2.445-1.418c.284-.059.72-.124 1.244-.09 1.721.109 2.911 1.182 3.81 1.992 1.19 1.07 1.84 2.141 2.265 2.852.353.593.903 1.525 1.29 2.882.332 1.17.414 2.19.42 2.911l-1.97 1.273-.443-3.492-2.045-3.353-1.95-1.963-3.221-1.468-1.845-.126z",
    fill: "#97C5CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.564 17.263 2.129-1.148A2.557 2.557 0 0 1 31.737 15c.203-.75.7-1.186.89-1.336l-2.203.47-1.094 2.73.236.4h-.002zM39.903 23.389l-1.096-4.498.512-.549.954 4.376z",
    fill: "#97C5CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6 16.702c-.042-.421-.073-1.342.43-2.289.13-.244.413-.761 1.005-1.197a3.29 3.29 0 0 1 1.23-.557c.913-.2 1.666.065 2.214.267 1.07.395 1.752.986 2.317 1.485 1.595 1.411 2.402 2.943 2.829 3.774.508.988.757 1.756.84 2.021.486 1.553.465 2.619.452 2.95a7.713 7.713 0 0 1-.012.23l-1.11-.597a6.693 6.693 0 0 0-.02-1.06c-.135-1.37-.67-2.358-1.263-3.429-.376-.679-.74-1.342-1.396-2.118-.636-.75-1.058-1.266-1.8-1.674-.494-.272-1.808-.993-3.006-.423-1.102.524-1.476 1.84-1.589 2.234-.109.38-.142.71-.153.944l-.964-.561H28.6z",
    fill: "#B2DFE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.541 32.758v6.36l2.304 1.231c.17.107.444.253.808.324.2.04.951.187 1.507-.23.494-.37.569-.988.62-1.394.162-1.32-.522-2.39-.875-2.936-.87-1.344-2.053-2.045-2.75-2.38l-1.614-.975z",
    fill: "#102129"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.432 34.485v4.051l1.468.785c.108.069.282.162.514.206.128.025.607.12.96-.148.314-.235.362-.628.395-.887.105-.842-.332-1.523-.556-1.872-.554-.856-1.31-1.302-1.752-1.515l-1.03-.622v.002z",
    fill: "#BAD8DD"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#102129",
    d: "M17.68 36.374v6.302l3.553 2.082v-1.06L18.68 42.24v-1.63l2.001 1.163V40.68l-1.984-1.04v-1.703l2.589 1.475v-1.005zM22.431 39.268v6.22l2.26 1.281c.15.097.455.267.87.295.185.012.632.042.93-.21.445-.38.361-1.19.106-1.669-.238-.444-.671-.688-.765-.74a2.152 2.152 0 0 0-.341-.154c.106.006.282 0 .47-.082.416-.183.567-.6.6-.692.264-.736-.27-1.47-.389-1.632a2.355 2.355 0 0 0-.798-.692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.53 41.016.016 1.479 1.148.572c.06.034.249.126.412.06.289-.117.224-.632.22-.67-.042-.305-.233-.507-.373-.654a2.103 2.103 0 0 0-.807-.524l-.617-.26v-.003zM23.548 43.44l.019 1.726 1.282.667c.067.038.278.147.46.07.322-.14.249-.739.242-.783-.048-.356-.259-.591-.414-.764a2.34 2.34 0 0 0-.9-.612l-.689-.307v.002z",
    fill: "#BAD8DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.488 39.382c.728.347 1.41.78 2.093 1.205.33.204.684.391.962.667.278.275.588.618.711.997.02.063.121.035.1-.028-.11-.342-.364-.633-.602-.898-.268-.3-.59-.498-.928-.709-.749-.462-1.49-.942-2.284-1.323-.06-.03-.113.061-.052.09v-.001z",
    fill: "#243D7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.598 40.118c.335.097.59.343.879.526.156.1.315.191.455.317.153.137.3.28.448.419.035.034.107 0 .088-.05a1.01 1.01 0 0 0-.226-.354c-.048-.048-.121.025-.073.074a.872.872 0 0 1 .198.307l.088-.05c-.152-.144-.303-.291-.46-.43-.144-.126-.305-.22-.464-.322-.297-.189-.56-.437-.903-.536-.065-.019-.092.082-.028.1l-.002-.001zM25.66 44.25c.29.199.594.411.78.723.197.33.222.725.224 1.102 0 .067.104.067.104 0 0-.396-.031-.81-.238-1.157-.194-.326-.51-.551-.816-.762-.056-.037-.108.053-.052.09l-.002.003z",
    fill: "#243D7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.497 44.302c.238.134.452.305.638.504.046.051.119-.025.073-.073a2.736 2.736 0 0 0-.659-.522c-.058-.033-.11.057-.052.09zM25.804 44.32c.377-.124.68-.416.824-.786.174-.444.073-.96-.209-1.332-.04-.052-.132 0-.09.053.264.345.36.808.21 1.224a1.233 1.233 0 0 1-.762.74c-.063.022-.035.123.027.102z",
    fill: "#243D7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.29 41.106c.54.341.968.846 1.215 1.437.025.061.127.034.1-.027a3.262 3.262 0 0 0-1.263-1.498c-.056-.036-.108.055-.052.09v-.002z",
    fill: "#243D7B"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#102129",
    d: "M27.212 41.84v1.195l1.708.915v5.27l1.058.523v-5.35l1.773.866v-1.127z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtCardDebt);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-card-debt.cfd121f688c6cf036cfba42eaf8a3706.svg";